import React,{ useEffect,useState,useContext } from 'react';
import { Link } from 'react-router-dom';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import { toast } from 'react-toastify';
import { Context } from '../../context/UserContext';
import ReactSelect from 'react-select';

const Index = () => {

    const context = useContext(Context);
    const {readData} = useEntityCrud('Branch/GetAllBranchs');
    const {addData: updateData} = useEntityCrud('Branch/ChangeStatus');
    const [rows,setRows] = useState([]);
    const [filteredRows,setFilteredRows] = useState([]);
    const [branches,setBranches] = useState([]);
    const [branchId,setBranchId] = useState('');
    const [title,setTitle] = useState('');
    const [searched,setSearched] = useState(false);
    const [currentPage,setCurrentPage] = useState(1);
    const [pages,setPages] = useState(0);

    const calcPages = result => {
        let calcPages = result.length / 10;
        calcPages = calcPages > 1 ? Math.ceil(calcPages) : 1
        let pagesArray = [];
        for (let i = 1; i <= calcPages; i++)
            pagesArray.push(i);
        setPages(pagesArray);
        setCurrentPage(1);
    }

    const getData = () => {
        readData().then(({data}) => {
            if(data.status){
                setRows(data.result);
                calcPages(data.result);
                const result = [...data.result.slice(0,10)]
                setFilteredRows(result);
            }
        });
    }

    useEffect(() => {
        getData();
        readData().then(({ data }) => {
            if(data.status)
                setBranches([...data.result.map(branch => ({label: branch.title,value: branch.id}))]);
        });
    },[]);

    const nextPage = () => {
        const skip = currentPage * 10;
        const result = [...rows.slice(skip,skip + 10)];
        setFilteredRows(result);
        setCurrentPage(currentPage + 1);
    }

    const prevPage = () => {
        const skip = (currentPage - 2) * 10;
        const result = [...rows.slice(skip,skip + 10)];
        setFilteredRows(result);
        setCurrentPage(currentPage - 1);
    }

    const deActiveRow = id => {
        const postedData = {
            id,
            status: false
        };
        updateData(postedData).then(({data}) => {
            if(data.status){
                toast.success('وضعیت شرکت زیر مجموعه مورد نظر با موفقیت به روزرسانی شد');
                const oldRows = [...filteredRows];
                const index = filteredRows.findIndex(row => row.id == id);
                oldRows[index].isActive = !filteredRows[index].isActive;
                setFilteredRows([...oldRows]);
            }else
                data.errors.map(error => toast.error(error.message));
        });
    }

    const activeRow = id => {
        const postedData = {
            id,
            status: true
        };
        updateData(postedData).then(({data}) => {
            if(data.status){
                toast.success('وضعیت شرکت زیر مجموعه مورد نظر با موفقیت به روزرسانی شد');
                const oldRows = [...filteredRows];
                const index = filteredRows.findIndex(row => row.id == id);
                oldRows[index].isActive = !filteredRows[index].isActive;
                setFilteredRows([...oldRows]);
            }else
                data.errors.map(error => toast.error(error.message));
        });
    }

    const search = () => {
        let allRows = [...rows]
        if(title)
            allRows = allRows.filter(row => row.title.includes(title))
        if(branchId)
            allRows = allRows.filter(row => row.parentId == branchId)
        calcPages(allRows);
        setFilteredRows(allRows)
        setSearched(true);
        setCurrentPage(1);
    }

    const clearSearch = () => {
        setTitle('')
        setBranchId('')
        setFilteredRows([...rows])
        setSearched(false);
    }

    return (
        <div className="card">
            <div className="card-header">
                <div className="card-title">شرکت های زیر مجموعه</div>
            </div>
            <div className="card-body">
                {context.checkHasPermission('create') ? <Link className="btn btn-primary" to="create">ایجاد شرکت زیر مجموعه جدید</Link> : ''}
                <button className="btn btn-dark mx-2 accordion-toggle collapsed" data-bs-toggle="collapse" data-bs-parent="#accordion" href="#collapseFour" aria-expanded="false">جستجو</button>
                <div className="panel-group1 mt-3" id="accordion1">
                    <div id="collapseFour" className="panel-collapse collapse position-relative" role="tabpanel" aria-expanded="false">
                        <div className="row">
                            <div className="col-md-2">
                                <div className="form-group">
                                    <label>عنوان</label>
                                    <input className="form-control" value={title} onChange={e => setTitle(e.target.value)} />
                                </div>
                            </div>
                            <div className="col-md-2">
                                <div className="form-group">
                                    <label>شرکت</label>
                                    {branchId ? <i className="fe fe-x clear-select-btn" onClick={e => setBranchId('')}></i> : ''}
                                    <ReactSelect noOptionsMessage={e => 'یافت نشد'} placeholder="  همه موارد " options={branches} value={branches.filter(b => b.value == branchId)} onChange={e => setBranchId(e.value)} />
                                </div>
                            </div>
                            <div className="col-md-4" style={{marginTop: 29}}>
                                <button className="btn btn-success me-2" onClick={search}>جستجو</button>
                                {searched ? <button className="btn btn-danger" onClick={clearSearch} type="button">بازنشانی</button> : ''}
                            </div>
                        </div>
                    </div>
                </div>
                {context.checkHasPermission('create') ? <hr /> : ''}
                {filteredRows.length ? <div className="table-responsive"><table className="table table-bordered table-hover border text-nowrap text-md-nowrap">
                    <thead>
                        <tr>
                            <th>ردیف</th>
                            <th>عنوان</th>
                            <th>والد</th>
                            <th>شماره تماس</th>
                            <th>وضعیت</th>
                            <th>عملیات</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredRows.map((item,index) => (
                            <tr key={index}>
                                <td>{(currentPage - 1) * 10 + (index + 1)}</td>
                                <td>{item.title}</td>
                                <td>{item.parentTitle || '-'}</td>
                                <td>{item.phone}</td>
                                <td>{item.isActive ? <i className="fe fe-check text-success"></i> : <i className="fe fe-x text-danger"></i>}</td>
                                <td className="btn-list">
                                    {context.checkHasPermission('update') ? <Link to={'update/' + item.id} className="btn btn-icon mb-0 btn-primary" title="ویرایش"><i className="fe fe-edit-2"></i></Link> : ''}
                                    {context.checkHasPermission('update') ? (item.isActive ? <button onClick={e => deActiveRow(item.id)} className="btn btn-icon mb-0 btn-danger" title="غیرفعال سازی"><i className="fe fe-x"></i></button> : <button onClick={e => activeRow(item.id)} className="btn btn-icon mb-0 btn-success" title="فعال سازی"><i className="fe fe-check"></i></button>) : ''}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <p>تعداد کل ردیف ها : {rows.length || 0}</p>
                {pages.length > 1 && <div className="text-center">
                    <button className="btn btn-primary me-2" disabled={currentPage == 1} onClick={prevPage}>قبلی</button>
                    <button className="btn btn-primary" disabled={currentPage == pages.length} onClick={nextPage}>بعدی</button>
                </div>}
                </div> : <div className="alert alert-info"><p>شرکت زیر مجموعه ای یافت نشد</p></div>}
            </div>
        </div>
    );
}

export default Index;